(function() {
'use strict';
	angular.module('app')
		.controller('DashboardAccountingController', function($scope, $location) {
		$scope.accountingTableData = {
			'head': [{
				title: 'Date Range',
				type: 'dateRange',
				names: ['dateFrom', 'dateTo']
			}, {
				name: 'customer',
				title: 'Customer'
			}, {
				title: 'Email',
				name: 'email'
			}, {
				title: 'Carrier',
				type: 'logo',
				logo: 'logo',
				sort: 'carrierName',
				template: 'logotype.html'
			}, {
				title: 'Service Type',
				name: 'serviceType'
			}, {
				title: 'Comparable Month Last Year ',
				name: 'comparableMonth'
			}, {
				title: 'Month',
				name: 'month'
			}, {
				title: 'Comparable Year',
				name: 'comparableYear'
			}, {
				title: 'Year',
				name: 'year'
			}, {
				title: 'View Customer Profile',
				type: 'action'
			}],
			'checked': false,
			'data': []
		};
		$scope.accountingTableData.data = [{
			dateFrom: '1/3/2014',
			dateTo: '1/3/2015',
			customer: 'Myer Pty Ltd',
			email: 'myerptyltd@myer.com',
			carrierName: 'Fastways',
			logo: '/images/shipping_company_logos/fastways.svg',
			serviceType: 'BBA Mastro Profile 1',
			comparableMonth: '$1,000 AUD',
			month: '$1,400 AUD',
			comparableYear: '$22,500 AUD',
			year: '$27,500 AUD',
			actions: [{
				text: 'View',
				action: function() {},
				type: 'btn-info btn-quirk'
			}]
		}, {
			dateFrom: '1/3/2014',
			dateTo: '1/3/2015',
			customer: 'Myer Pty Ltd',
			email: 'myerptyltd@myer.com',
			carrierName: 'Fastways',
			logo: '/images/shipping_company_logos/fastways.svg',
			serviceType: 'BBA Mastro Profile 1',
			comparableMonth: '$1,000 AUD',
			month: '$1,400 AUD',
			comparableYear: '$22,500 AUD',
			year: '$27,500 AUD',
			actions: [{
				text: 'View',
				action: function() {},
				type: 'btn-info btn-quirk'
			}]
		}, {
			dateFrom: '1/3/2014',
			dateTo: '1/3/2015',
			customer: 'Myer Pty Ltd',
			email: 'myerptyltd@myer.com',
			carrierName: 'Fastways',
			logo: '/images/shipping_company_logos/fastways.svg',
			serviceType: 'BBA Mastro Profile 1',
			comparableMonth: '$1,000 AUD',
			month: '$1,400 AUD',
			comparableYear: '$22,500 AUD',
			year: '$27,500 AUD',
			actions: [{
				text: 'View',
				action: function() {},
				type: 'btn-info btn-quirk'
			}]
		}, {
			dateFrom: '1/3/2014',
			dateTo: '1/3/2015',
			customer: 'Myer Pty Ltd',
			email: 'myerptyltd@myer.com',
			carrierName: 'Fastways',
			logo: '/images/shipping_company_logos/fastways.svg',
			serviceType: 'BBA Mastro Profile 1',
			comparableMonth: '$1,000 AUD',
			month: '$1,400 AUD',
			comparableYear: '$22,500 AUD',
			year: '$27,500 AUD',
			actions: [{
				text: 'View',
				action: function() {},
				type: 'btn-info btn-quirk'
			}]
		}, {
			dateFrom: '1/3/2014',
			dateTo: '1/3/2015',
			customer: 'Myer Pty Ltd',
			email: 'myerptyltd@myer.com',
			carrierName: 'Fastways',
			logo: '/images/shipping_company_logos/fastways.svg',
			serviceType: 'BBA Mastro Profile 1',
			comparableMonth: '$1,000 AUD',
			month: '$1,400 AUD',
			comparableYear: '$22,500 AUD',
			year: '$27,500 AUD',
			actions: [{
				text: 'View',
				action: function() {},
				type: 'btn-info btn-quirk'
			}]
		}];
	});
})();



// WEBPACK FOOTER //
// ./js/controllers/DashboardAccountingController.js